export default __webpack_public_path__ + "static/media/logo.978b0156.png";